<template>
  <div>
    <section class="section is-main-section">
      <h1 class="title">
        {{ title }}
      </h1>
      <div class="columns">
        <div class="column is-2">
          <b-datepicker
              v-model="fromdate"
              placeholder="ຈາກວັນທີ"
              :locale="this.getDateLocale"
              icon="calendar-today"
              @input="selectFromDate"
          >
          </b-datepicker>
        </div>
        <div class="column is-2">
          <b-datepicker
              v-model="todate"
              :locale="this.getDateLocale"
              placeholder="ຫາວັນທີ"
              icon="calendar-today"
              @input="selectToDate"
          >
          </b-datepicker>
        </div>
        <div class="column is-3">
          <b-select placeholder="ສາຂາ" expanded v-model="selectedBranchId" :disabled="enableSelect">
            <option :value="0">ທັງໝົດ</option>
            <option v-for="option in branches"
                    :value="option.id"
                    :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </div>
        <div class="column is-2">
          <button class="button" @click="get">
            <b-icon icon="magnify" />
          </button>
        </div>
        <div class="column is-2 has-text-left" v-if="models.length>0">
          <b-button
              @click="exportExcel"
              size="is-medium">
            <b-icon
                icon="file-excel-outline"
                style="margin-right: 0.5em"></b-icon>
            ດາວໂຫລດເປັນ excel
          </b-button>
        </div>
      </div>
      <card-component class="has-table has-mobile-sort-spaced">
        <div class="columns" style="padding: 1em">
          <div class="column title has-text-centered is-size-6">
            ເກັບຕົ້ນທາງ: {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===false ? 1:0;})}}, 
            ຈຳນວນເງີນ: 
            {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===false ? m.amount:0; }) | formatnumber }} ກີບ
            , {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===false ? m.amount_thb:0; }) | formatnumber }} ບາດ
          </div>
          <div class="column title has-text-centered is-size-6">
            ເກັບປາຍທາງ: {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===true ? 1:0;})}} , 
            ຈຳນວນເງີນ: 
            {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===true ? m.amount:0; }) | formatnumber }} ກີບ
            , {{ _.sumBy(models,(m)=>{ return m.is_receiver_pay===true ? m.amount_thb:0; }) | formatnumber }} ບາດ
          </div>
        </div>
        <hr />
        <b-table
            :loading="isLoading"
            :paginated="perPage < models.length"
            :per-page="perPage"
            :striped="true"
            :hoverable="true"
            default-sort="created_date"
            :data="models"
            :current-page.sync="currentPage"
            :pagination-rounded="true" 
            :narrowed="true" class="is-size-7"
        >
          <b-table-column label="#" v-slot="props">
            {{ props.index+(currentPage>1?(perPage*currentPage-perPage):0)+1 }}
          </b-table-column>
          <b-table-column
              label="ວັນທີ"
              field="created_date"
              sortable
              v-slot="props"
          >
            {{ props.row.created_date | datetime }}
          </b-table-column>
          <b-table-column label="ລະຫັດ" field="code" sortable v-slot="props">
            <router-link :to="'/shipment/' + props.row.code">
              {{ props.row.code }} <b-tag v-if="props.row.is_cod" type="is-warning">COD</b-tag>
            </router-link>
          </b-table-column>
          <b-table-column
              label="ຜູ້ສົ່ງ"
              field="sendername"
              sortable
              v-slot="props"
          >
            {{ props.row.sendername }}
          </b-table-column>
          <b-table-column
              label="ຜູ້ຮັບ"
              field="receivername"
              sortable
              v-slot="props"
          >
            {{ props.row.receivername }}
          </b-table-column>
          <b-table-column
              label="ສາຂາຕົ້ນທາງ"
              field="branch_branchToshipment_from_branch_id.name "
              sortable
              v-slot="props"
          >
            {{ props.row.branch_branchToshipment_from_branch_id.name }}
          </b-table-column>
          <b-table-column
              label="ສາຂາປາຍທາງ"
              field="branch_branchToshipment_to_branch_id.name"
              sortable
              v-slot="props"
          >
            {{ props.row.branch_branchToshipment_to_branch_id.name }}
          </b-table-column>
          <b-table-column
              label="ຈຳນວນເງິນກີບ"
              field="amount"
              sortable
              v-slot="props"
              cell-class="has-text-right"
          >
            {{ props.row.amount | formatnumber }}
          </b-table-column>
           <b-table-column
            label="ຈຳນວນເງິນບາດ"
            field="amount"
            sortable
            v-slot="props"
            cell-class="has-text-right"
          >
            {{ props.row.amount_thb | formatnumber }}
          </b-table-column>
          <b-table-column
              label="COD ກີບ"
              sortable
              v-slot="props"
          >
            {{props.row.cod_lak | formatnumber}}
          </b-table-column>
          <b-table-column
              label="COD ບາດ"
              sortable
              v-slot="props"
          >
            {{props.row.cod_thb | formatnumber}}
          </b-table-column>
          <b-table-column
              label="ສະຖານະ"
              field="status"
              sortable
              v-slot="props"
              cell-class="has-text-centered"
          >
            <shipment-status :status="props.row.status" />
          </b-table-column>

          <empty-table v-if="models.length == 0" :isLoading="isLoading" />
        </b-table>
      </card-component>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";
import CardComponent from "@/components/CardComponent";
import EmptyTable from "../components/EmptyTable.vue";
import ShipmentStatus from "../components/ShipmentStatus.vue";
import moment from "moment";
import XLSX from "xlsx";
import store from "@/store";

export default {
  name: "ShipmentFromBranch",
  components: { CardComponent, EmptyTable, ShipmentStatus },
  computed: {
    user: get("user"),
    branches:  get('branches'),
    shipmentStatuses: get("shipmentStatuses"),
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      title: "ເຄຶ່ອງທີ່ອອກຈາກສາຂາ",
      models: [],
      isShowModal: false,
      isLoading: false,
      fromdate: new Date(),
      todate: new Date(),
      selectedBranchId: 0,
      enableSelect: true
    };
  },
  mounted() {
    this.selectedBranchId =  this.user.branch_id
    this.enableSelect   = this.user.role !== 'ADMIN'
    this.get();

  },
  watch: {
    models: function () {
      this.isLoading = false;
    },
  },
  methods: {
    get() {
      this.isLoading = true;
      const fdate = moment(this.fromdate).format("YYYY-MM-DD");
      const tdate = moment(this.todate).format("YYYY-MM-DD");

      const query = {branchid: this.selectedBranchId};

      axios.get(`report/shipmentfrombranch/${fdate}/${tdate}`, {params:  query}).then((r) => {
        this.models = r;
      });
    },
    view(item) {
      this.$router.push({ path: "/report/shipment/" + item.id });
    },
    selectFromDate(e) {
      console.log(e);
    },
    selectToDate(e) {
      console.log(e);
    },
    formattedCod(cod) {
      if(!cod) return "-"
      if(cod.length === 0) return "-";
      const codStr = cod.map((c) => `<span class="tag is-info is-small">${this.$options.filters.formatnumber(c.amount)}-${c.ccy}</span>`).join("");
      return codStr;
    },
    getUserBranchInfo() {
      return store.getters.getUserIdBranchInfo;
    },
    exportExcel() {
      if (this.models.length<1 ) return;
      //Create workBook
      const workBook = XLSX.utils.book_new();
      /* worksheet  data */
      const header =[

        "ວັນທີ່ສ້າງລາຍການ",
        "ລະຫັດເຄື່ອງ",
        "ຊື່ຜູ້ສົ່ງ",
        "ເບີໂທຜູ້ສົ່ງ",
        "ຊື່ຜູ້ຮັບ",
        "ສາຂາຕົ້ນທາງ",
        "ສາຂາປາຍທາງ",
        "ສະຖານະ",
        "ວັນທີ່ຈ່າຍເຄື່ອງ",
        "ຄ່າຝາກກີບ",
        "ຄ່າຝາກບາດ",
        "ຈຳນວນເງີນຄ່າເຄື່ອງເປັນກີບ",
        "ຈຳນວນເງີນຄ່າເຄື່ອງເປັນບາດ",
        "ໝາຍເຫດ"
      ];

      const ws_data_sheet = [];
      ws_data_sheet.push(header);
      for (const item of this.models) {
        ws_data_sheet.push([
          moment(item.created_date).format("YYYY-MM-DD HH:mm:ss"),
          item.code
          ,item.sendername
          ,item.sendertel
          ,item.receivername
          ,item.branch_branchToshipment_from_branch_id.name
          ,item.branch_branchToshipment_to_branch_id.name
          ,this.shipmentStatuses[item.status].label
          ,item.delivery_date?moment(item.delivery_date).format("YYYY-MM-DD HH:mm:ss"):''
          ,item.amount
          ,item.amount_thb
          ,item.cod_lak
          ,item.cod_thb
          ,item.is_receiver_pay?"ຄ່າຝາກເກັບປາຍທາງ":""
        ]);
      }
      /* create worksheet */
      const ws = XLSX.utils.aoa_to_sheet(ws_data_sheet);
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(workBook, ws, "ຄ່າສົ່ງເຄື່ງ");

      /* Write workbook to file */
      const _date = moment(this.selectedDate).format("YYYY_MM_DD_HHmmss");
      const _ub = this.getUserBranchInfo();
      XLSX.writeFile(workBook, `SHIPMENT_FROM_${_ub}_FILE_${_date}.xlsx`);
    },
  }
};
</script>